'use client';

import * as DS from '@aurorasolar/ds';

import { TRACKING } from '@/helpers/tracking';

import { flowMobileOne, flowMobileThree, flowMobileTwo } from '../assets';

import { ButtonLink } from './ButtonLink';
import { H2 } from './H2';
import { Section } from './Section';

export const ShoppingHighlights = () => (
  <>
    <Section
      columnGap={5}
      imageRight={{ alt: 'Mobile screen showing solar estimate shopping flow', height: 400, src: flowMobileOne }}
    >
      <H2>Shop at your pace</H2>
      <p>
        Getting estimates on your terms with Aurora is simple. You share project details, we gather estimates, and you
        choose when to move forward.
      </p>
    </Section>

    <Section columnGap={5} imageLeft={{ alt: 'Solar made simple', height: 400, src: flowMobileTwo }}>
      <H2>Solar made simple</H2>
      <p>
        Shopping for solar shouldn&apos;t be overwhelming. That&apos;s why we&apos;re dedicated to making solar easy to
        understand. We unpack all the information you need to make an informed decision, so you can confidently choose
        the best solar solution for your home.
      </p>
    </Section>

    <Section columnGap={5} imageRight={{ alt: 'Choose your perfect deal', height: 400, src: flowMobileThree }}>
      <H2>Choose your perfect deal</H2>
      <p>
        Choose the perfect solar deal for your home by comparing reviews, prices, and reputations of top installers.
        Plus, explore financing options that fit your budget and lifestyle.
      </p>
      <ButtonLink
        event={{ name: TRACKING.LANDING_CLICK_GET_QUOTE }}
        icon={DS.IconArrowRight}
        iconPosition="right"
        path="/quote-builder"
        size="md"
        variant="cta"
      >
        Start your estimate
      </ButtonLink>
    </Section>
  </>
);
